import api from './api';
import { Sale, SaleCreateDto } from '../types/types';

export const salesService = {
    // Create new sale
    createSale: async (saleData: SaleCreateDto): Promise<Sale> => {
        const response = await api.post<Sale>('/sales', saleData);
        return response.data;
    },

    // Get sale by ID
    getSaleById: async (id: number): Promise<Sale> => {
        const response = await api.get<Sale>(`/sales/${id}`);
        return response.data;
    },

    // Get all sales (Admin only)
    getAllSales: async (): Promise<Sale[]> => {
        const response = await api.get<Sale[]>('/sales');
        return response.data;
    },
};
